import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3da64a7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-box-container" }
const _hoisted_2 = { class: "grid-container" }
const _hoisted_3 = { class: "custom-cell" }
const _hoisted_4 = { class: "custom-cell" }
const _hoisted_5 = { class: "custom-cell" }

import {
  computed,
  inject,
  nextTick,
  onMounted,
  PropType,
  ref,
  watch,
} from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { AppointmentConfigurationType } from "@/types/configuration/AppointmentConfigurationType";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import displayErrorMessage from "@/utils/ErrorHandling";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { EditAppointment } from "@/types/diary/EditAppointment";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { SMSCredits } from "@/types/sms/SMSCredits";
import EmailTemplatesConfigurationModal from "@/components/email/email-templates-configuration-modal.vue";
import SmsTextsConfigurationTemplates from "@/components/sms-texts-configuration-templates.vue";
import { AppointmentContactItem } from "@/types/contacts/AppointmentContactItem";
import { formatDate } from "bright-logic-core/src/format";
import EmailFormModal from "@/components/email/email-form-modal.vue";
import SmsForm from "@/components/sms/sms-form.vue";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import FindContactModal from "@/components/find/contacts/find-contact-modal.vue";
import { ContactFindResult } from "@/types/find/contacts/ContactFindResult";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";
import { AppointmentNotificationItem } from "@/types/contacts/AppointmentNotificationItem";
import { BulkAppointmentConfirmation } from "@/types/contacts/BulkAppointmentConfirmation.ts";
import { ContactBulkAppointmentConfirmation } from "@/types/contacts/ContactBulkAppointmentConfirmation";


export default /*#__PURE__*/_defineComponent({
  __name: 'appointment-confirmation-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /** Indicates object of the appointment.
   * @property {EditAppointment} appointment - The object of the appointment.
   */
  appointment: {
    type: Object as PropType<EditAppointment>,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when the modal is closed.
   * This can be used to notify the parent component that the modal has been dismissed.
   */
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;





onMounted(async () => {
  currentUserDetails.value = await currentUserStore.getCurrentUserDetails();
});

const showModal = computed({
  get: () => props.modelValue,
  set: (value: Boolean) => emit("update:modelValue", value),
});

const currentUserStore = useCurrentUserStore();
const currentUserDetails = ref<CurrentUser>();
const appointmentData = ref({ ...props.appointment });
const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const systemConfigurationStore = useSystemConfigurationStore();
const dropdownIcon = ref("fa-sharp fa-solid fa-caret-down");
const emailConfirmationTemplate = ref<IDDescriptionPair>({
  id: -1,
  description: "",
});
const emailNotificationTemplate = ref<IDDescriptionPair>({
  id: -1,
  description: "",
});
const smsConfirmationTemplate = ref<IDDescriptionPair>({
  id: -1,
  description: "",
});
const smsNotificationTemplate = ref<IDDescriptionPair>({
  id: -1,
  description: "",
});
const originalAppointmentTypeData = ref<AppointmentConfigurationType>();
const appointmentTypeData = ref<AppointmentConfigurationType>();
const bulkAppointmentNotification = ref<BulkAppointmentConfirmation>({
  appointmentId: props.appointment.id,
  appointmentTypeId: props.appointment.typeId,
  emailConfirmationTemplateId: emailConfirmationTemplate.value.id,
  emailNotificationTemplateId: emailNotificationTemplate.value.id,
  smsConfirmationTemplateId: smsConfirmationTemplate.value.id,
  smsNotificationTemplateId: smsNotificationTemplate.value.id,
  contacts: [],
});
const appointmentContactList = ref<AppointmentContactItem[]>([]);
const initalAppointmentContact = ref<AppointmentContactItem>({
  contactId: 0,
  name: "",
  isAttending: false,
  typeId: 0,
  type: "",
  email: "",
  mobile: "",
  sendEmail: false,
  sendSms: false,
  linkedTo: 0,
  appointmentContact: false,
  emailConfirmationDate: "",
  smsConfirmationDate: "",
  propertyId: 0,
});
const selectedAppointmentContact = ref<AppointmentContactItem>({
  ...initalAppointmentContact.value,
});
const appointmentNotificationItems = ref<AppointmentNotificationItem[]>([]);
const loadingContent = ref(false);
const keepingModalOpening = ref(false);
const displayCancelConfirmationModal = ref(false);
const displayEmailTemplateModal = ref(false);
const displaySmsTemplateModal = ref(false);
const displayEmailConfirmationModal = ref(false);
const displayEmailNotificationModal = ref(false);
const displaySmsConfirmationModal = ref(false);
const displaySmsNotificationModal = ref(false);
const displayFindContactModal = ref(false);
const isSendingAppointmentConfirmations = ref(false);
const isEmailSmsCancelled = ref(false);
const confirmationKey = ref("");
const emailCredits = ref(0);
const smsCredits = ref(0);
const templateIdForEmailConfirmation = ref(0);
const templateIdForEmailNotification = ref(0);
const templateIdForSmsConfirmation = ref(0);
const templateIdForSmsNotification = ref(0);
const contactListForEmailConfirmation = ref<number[]>([]);
const contactListForEmailNotification = ref<number[]>([]);
const contactListForSmsConfirmation = ref<number[]>([]);
const contactListForSmsNotification = ref<number[]>([]);
const resolveModal = ref<(() => void) | null>(null);

watch(
  () => appointmentData,
  () => {
    displayCancelConfirmationModal.value =
      JSON.stringify(appointmentData.value) !=
      JSON.stringify(props.appointment);
  },
  { deep: true },
);

const refreshModalData = async () => {
  await getEmailCredits();
  await fetchSmsCredits();
  await fetchAppointmentContacts();
};

const getEmailCredits = async () => {
  try {
    emailCredits.value = await apiNextClient.httpGet(
      "/Email/getemailcreditbalance",
    );
  } catch (err) {
    emailCredits.value = 0;
    displayErrorMessage(getErrorMessage(err));
  }
};

const fetchSmsCredits = async () => {
  try {
    const rawCredits = await acquaintApiClient.httpGet<SMSCredits>(
      "app/correspondence/sms/credits",
    );
    smsCredits.value = rawCredits.total;
  } catch (err) {
    smsCredits.value = 0;
    displayErrorMessage(getErrorMessage(err));
  }
};

const fetchAppointmentContacts = async () => {
  try {
    appointmentContactList.value = await acquaintApiClient.httpGet<
      AppointmentContactItem[]
    >(`app/contacts/${props.appointment.id}/appointment`);
  } catch (err) {
    appointmentContactList.value = [];
    displayErrorMessage(getErrorMessage(err));
  }
};

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value || keepingModalOpening.value) {
      return;
    }
    if (props.appointment.typeId == 0) {
      return;
    }
    loadingContent.value = true;

    await refreshModalData();
    await fetchTypeData();

    const sendingConfirmation =
      await systemConfigurationStore.getSystemConfigurationValue(
        SystemConfiguration.PreviewBeforeSendingAppointmentConfirmations,
      );
    isSendingAppointmentConfirmations.value =
      sendingConfirmation == "1" ? true : false;

    emailConfirmationTemplate.value = (await fetchEmailTemplateById(
      appointmentTypeData.value?.emailConfirmationTemplateID,
    )) ?? { id: -1, description: "" };
    emailNotificationTemplate.value = (await fetchEmailTemplateById(
      appointmentTypeData.value?.emailNotificationTemplateID,
    )) ?? { id: -1, description: "" };

    smsConfirmationTemplate.value = (await fetchSmsTextTemplateById(
      appointmentTypeData.value?.smsConfirmationTemplateID,
    )) ?? { id: -1, description: "" };
    smsNotificationTemplate.value = (await fetchSmsTextTemplateById(
      appointmentTypeData.value?.smsNotificationTemplateID,
    )) ?? { id: -1, description: "" };
    loadingContent.value = false;
  },
  { immediate: true },
);

const getAppointmentContactByIds = async (contactId: number) => {
  try {
    return await apiNextClient.httpGet<AppointmentContactItem>(
      `Appointment/${props.appointment.id}/Contact/${contactId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

const updateConfirmationNotifications = async () => {
  try {
    return await apiNextClient.httpPostVoid(
      `Appointment/${props.appointment.id}/UpdateConfirmationNotifications`,
      appointmentNotificationItems.value,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};
const sendBulkConfirmationNotifications = async () => {
  try {
    await apiNextClient.httpPost(
      `Appointment/BulkConfirmationNotifications`,
      bulkAppointmentNotification.value,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};
const fetchTypeData = async () => {
  try {
    originalAppointmentTypeData.value =
      await acquaintApiClient.httpGet<AppointmentConfigurationType>(
        `database/appointmenttypes/${props.appointment.typeId}`,
      );

    appointmentTypeData.value = JSON.parse(
      JSON.stringify(originalAppointmentTypeData.value),
    );
  } catch (err) {
    if (props.appointment.typeId == 0) {
      displayErrorMessage("We could not fetch the default data");
    } else {
      displayErrorMessage(
        "The selected appointment type data could not be fetched",
      );
    }
    originalAppointmentTypeData.value = undefined;
    appointmentTypeData.value = originalAppointmentTypeData.value;
  }
};

const fetchEmailTemplateById = async (id: number | undefined) => {
  try {
    if (id == undefined) return { id: -1, description: "" };

    return await acquaintApiClient.httpGet<IDDescriptionPair>(
      `app/system/lookup/${LookupTableSource.EmailTemplates}/${id}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

const fetchSmsTextTemplateById = async (id: number | undefined) => {
  try {
    if (id == undefined) return { id: -1, description: "" };

    return await acquaintApiClient.httpGet<IDDescriptionPair>(
      `app/system/lookup/${LookupTableSource.SMSTemplates}/${id}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

const onConfigTemplateClick = (key: string) => {
  switch (key) {
    case "emailConfirmation":
      confirmationKey.value = "emailConfirmation";
      displayEmailTemplateModal.value = true;
      break;
    case "emailNotification":
      confirmationKey.value = "emailNotification";
      displayEmailTemplateModal.value = true;
      break;
    case "smsConfirmation":
      confirmationKey.value = "smsConfirmation";
      displaySmsTemplateModal.value = true;
      break;
    case "smsNotification":
      confirmationKey.value = "smsNotification";
      displaySmsTemplateModal.value = true;
      break;
    default:
      break;
  }
};

const onEmailTemplateSelected = async (
  templateId: number,
  isMarketing: boolean,
  templateDescription: string,
) => {
  if (appointmentTypeData.value) {
    switch (confirmationKey.value) {
      case "emailConfirmation":
        appointmentTypeData.value.emailConfirmationTemplateID = templateId;
        emailConfirmationTemplate.value = {
          id: templateId,
          description: templateDescription,
        };
        break;
      case "emailNotification":
        appointmentTypeData.value.emailNotificationTemplateID = templateId;
        emailNotificationTemplate.value = {
          id: templateId,
          description: templateDescription,
        };
        break;
      default:
        break;
    }
  }
};
const onSmsTemplateSelected = async (
  templateId: number,
  isMarketing: boolean,
  templateDescription: string,
) => {
  if (appointmentTypeData.value) {
    switch (confirmationKey.value) {
      case "smsConfirmation":
        appointmentTypeData.value.smsConfirmationTemplateID = templateId;
        smsConfirmationTemplate.value = {
          id: templateId,
          description: templateDescription,
        };
        break;
      case "smsNotification":
        appointmentTypeData.value.smsNotificationTemplateID = templateId;
        smsNotificationTemplate.value = {
          id: templateId,
          description: templateDescription,
        };
        break;
      default:
        break;
    }
  }
};

const onSendClick = async () => {
  if (isSendingAppointmentConfirmations.value) {
    await processGridItems(false);
  } else {
    await processGridItems(true);
    await sendBulkConfirmationNotifications();
    showModal.value = false;
  }
};

const processGridItems = async (isBulk: boolean) => {
  // Reset values before processing
  isEmailSmsCancelled.value = false;
  contactListForEmailConfirmation.value = [];
  contactListForEmailNotification.value = [];
  contactListForSmsConfirmation.value = [];
  contactListForSmsNotification.value = [];
  selectedAppointmentContact.value = { ...initalAppointmentContact.value };

  // If bulk processing, reset bulkAppointmentNotification
  if (isBulk) {
    bulkAppointmentNotification.value = {
      appointmentId: props.appointment.id,
      appointmentTypeId: props.appointment.typeId,
      emailConfirmationTemplateId: emailConfirmationTemplate.value.id,
      emailNotificationTemplateId: emailNotificationTemplate.value.id,
      smsConfirmationTemplateId: smsConfirmationTemplate.value.id,
      smsNotificationTemplateId: smsNotificationTemplate.value.id,
      contacts: [],
    };
  }

  const processContact = async (
    item: AppointmentContactItem,
    isEmail: boolean,
  ) => {
    if (isBulk) {
      // Find existing item by contactId
      const existingItemIndex =
        bulkAppointmentNotification.value?.contacts.findIndex(
          (b) => b.contactId === item.contactId,
        );

      if (existingItemIndex !== -1) {
        // Update existing item
        bulkAppointmentNotification.value.contacts[existingItemIndex] = {
          ...bulkAppointmentNotification.value.contacts[existingItemIndex],
          sendEmail: isEmail
            ? !!item.email
            : bulkAppointmentNotification.value.contacts[existingItemIndex]
                .sendEmail,
          sendSms: !isEmail
            ? !!item.mobile
            : bulkAppointmentNotification.value.contacts[existingItemIndex]
                .sendSms,
        };
      } else {
        // Create a new item
        const newBulkAppointmentNotificationItem: ContactBulkAppointmentConfirmation =
          {
            contactId: item.contactId,
            propertyId: item.propertyId ?? 0,
            isAttending: item.isAttending,
            email: item.email ?? "",
            mobile: item.mobile ?? "",
            sendEmail: isEmail && !!item.email,
            sendSms: !isEmail && !!item.mobile,
          };

        bulkAppointmentNotification.value.contacts.push(
          newBulkAppointmentNotificationItem,
        );
      }
      return;
    }

    // Process individual contact notifications
    selectedAppointmentContact.value = item;

    if (isEmail) {
      displayEmailConfirmationModal.value = item.isAttending;
      displayEmailNotificationModal.value = !item.isAttending;

      templateIdForEmailConfirmation.value = emailConfirmationTemplate.value.id;
      templateIdForEmailNotification.value = emailNotificationTemplate.value.id;

      (item.isAttending
        ? contactListForEmailConfirmation
        : contactListForEmailNotification
      ).value.push(item.contactId);
    } else {
      displaySmsConfirmationModal.value = item.isAttending;
      displaySmsNotificationModal.value = !item.isAttending;

      templateIdForSmsConfirmation.value = smsConfirmationTemplate.value.id;
      templateIdForSmsNotification.value = smsNotificationTemplate.value.id;

      (item.isAttending
        ? contactListForSmsConfirmation
        : contactListForSmsNotification
      ).value.push(item.contactId);
    }

    // Wait for modal event before proceeding
    await new Promise<void>((resolve) => {
      resolveModal.value = resolve;
    });

    if (isEmail) {
      displayEmailConfirmationModal.value = false;
    } else {
      displaySmsConfirmationModal.value = false;
    }

    await nextTick();
  };

  // Process contacts for email and SMS in a single loop
  for (const item of appointmentContactList.value) {
    if (item.sendEmail) await processContact(item, true);
    if (item.sendSms) await processContact(item, false);
  }

  if (!isBulk) {
    await updateConfirmationNotifications();
    if (isEmailSmsCancelled.value) {
      await refreshModalData();
      standardInfoAlert(
        "One or more Appointment Confirmations or Notifications have not been sent.",
      );
    } else {
      showModal.value = false;
    }
  }
};

const onEmailSent = async () => {
  if (resolveModal.value) {
    resolveModal.value();
    resolveModal.value = null;
  }

  updateOrAddNotificationItem(true);
};
const onSmsSent = async () => {
  if (resolveModal.value) {
    resolveModal.value();
    resolveModal.value = null;
  }

  updateOrAddNotificationItem(false);
};
const updateOrAddNotificationItem = (isEmail: boolean) => {
  const index = appointmentNotificationItems.value.findIndex(
    (item) => item.contactId === selectedAppointmentContact.value.contactId,
  );

  if (index !== -1) {
    // Update the existing item
    appointmentNotificationItems.value[index] = {
      ...appointmentNotificationItems.value[index],
      sendEmail: isEmail
        ? true
        : appointmentNotificationItems.value[index].sendEmail,
      sendSms: !isEmail
        ? true
        : appointmentNotificationItems.value[index].sendSms,
    };
  } else {
    // Add a new item
    appointmentNotificationItems.value.push({
      contactId: selectedAppointmentContact.value.contactId,
      propertyId: selectedAppointmentContact.value.propertyId,
      isAttending: selectedAppointmentContact.value.isAttending,
      sendEmail: isEmail,
      sendSms: !isEmail,
    });
  }
};

const onCancelPromptAccepted = () => {
  if (resolveModal.value) {
    resolveModal.value();
    resolveModal.value = null;
  }
  isEmailSmsCancelled.value = true;
};
const onContactSelected = async (contact: ContactFindResult) => {
  if (!contact) {
    return;
  }

  const contactAlreadyInList = appointmentContactList.value.find((record) => {
    return record.contactId == contact.id;
  });

  if (contactAlreadyInList) {
    await standardInfoAlert("The selected contact has already been added.");
    return;
  }

  const newContact = await getAppointmentContactByIds(contact.id);
  if (newContact)
    appointmentContactList.value = [
      ...appointmentContactList.value,
      newContact,
    ];
};

const modalClosed = async () => {
  keepingModalOpening.value = false;
  displayCancelConfirmationModal.value = false;
  emit("modalClosed", false);
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const onCancelClick = () => {
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showModal).value = $event)),
      title: "Appointment Confirmation",
      showCloseButton: true,
      width: _unref(ModalWidth).Large,
      height: "725px",
      showCloseConfirmationPrompt: displayCancelConfirmationModal.value,
      onModalClosed: modalClosed,
      onCancelPromptDenied: cancelPromptDenied,
      loadingContent: loadingContent.value
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(AcquaintInfoBox, {
            icon: dropdownIcon.value,
            label: "Attendee Email Template",
            text: emailConfirmationTemplate.value.description,
            onIconClicked: _cache[0] || (_cache[0] = ($event: any) => (onConfigTemplateClick('emailConfirmation')))
          }, null, 8, ["icon", "text"]),
          _createVNode(AcquaintInfoBox, {
            icon: dropdownIcon.value,
            label: "Notification Email Template",
            text: emailNotificationTemplate.value.description,
            onIconClicked: _cache[1] || (_cache[1] = ($event: any) => (onConfigTemplateClick('emailNotification')))
          }, null, 8, ["icon", "text"]),
          _createVNode(AcquaintInfoBox, {
            icon: dropdownIcon.value,
            label: "Attendee SMS Template",
            text: smsConfirmationTemplate.value.description,
            onIconClicked: _cache[2] || (_cache[2] = ($event: any) => (onConfigTemplateClick('smsConfirmation')))
          }, null, 8, ["icon", "text"]),
          _createVNode(AcquaintInfoBox, {
            icon: dropdownIcon.value,
            label: "Notification SMS Template",
            text: smsNotificationTemplate.value.description,
            onIconClicked: _cache[3] || (_cache[3] = ($event: any) => (onConfigTemplateClick('smsNotification')))
          }, null, 8, ["icon", "text"]),
          _createVNode(AcquaintInfoBox, {
            text: emailCredits.value.toString(),
            label: "Email Credits Remaining"
          }, null, 8, ["text"]),
          _createVNode(AcquaintInfoBox, {
            text: smsCredits.value.toString(),
            label: "SMS Credits Remaining"
          }, null, 8, ["text"]),
          _createVNode(SwitchToggle, {
            class: "span-columns",
            label: "Preview Emails/SMS Texts Before Sending",
            modelValue: isSendingAppointmentConfirmations.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isSendingAppointmentConfirmations).value = $event)),
            readOnly: false,
            "margin-bottom": "0rem"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(GridBase, {
            dataSource: appointmentContactList.value,
            "id-column-name": "contactId",
            "column-auto-width": true,
            "column-hiding-enabled": true,
            wordWrapEnabled: true,
            customColumnSlots: [
            'attendingTemplate',
            'emailConfirmationDateTemplate',
            'smsConfirmationDateTemplate',
            'sendSmsTemplate',
            'sendEmailTemplate',
          ]
          }, {
            columns: _withCtx(() => [
              _createVNode(_unref(DxColumn), {
                "data-field": "name",
                caption: "Name",
                width: "150px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "isAttending",
                caption: "Attending",
                "cell-template": "attendingTemplate",
                width: "80px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "type",
                caption: "Type",
                width: "90px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "email",
                caption: "Email",
                width: "175px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "mobile",
                caption: "Mobile",
                width: "100px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "emailConfirmationDate",
                caption: "Emailed Date",
                "data-type": "date",
                format: "dd/MM/yyyy HH:mm",
                width: "100px",
                "cell-template": "emailConfirmationDateTemplate"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "smsConfirmationDate",
                caption: "SMS Date",
                "data-type": "date",
                format: "dd/MM/yyyy HH:mm",
                width: "85px",
                "cell-template": "smsConfirmationDateTemplate"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "sendEmail",
                caption: "Send Email",
                "cell-template": "sendEmailTemplate",
                width: "90px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "sendSms",
                caption: "Send SMS",
                "cell-template": "sendSmsTemplate",
                width: "110px"
              })
            ]),
            attendingTemplateData: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(data.isAttending ? "Yes" : "No"), 1)
            ]),
            emailConfirmationDateTemplateData: _withCtx(({ data }) => [
              _createElementVNode("span", null, _toDisplayString(data.emailConfirmationDate
                ? _unref(formatDate)(data.emailConfirmationDate, true)
                : "Not sent"), 1)
            ]),
            smsConfirmationDateTemplateData: _withCtx(({ data }) => [
              _createElementVNode("span", null, _toDisplayString(data.smsConfirmationDate
                ? _unref(formatDate)(data.smsConfirmationDate, true)
                : "Not sent"), 1)
            ]),
            sendEmailTemplateData: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(SwitchToggle, {
                  modelValue: data.sendEmail,
                  "onUpdate:modelValue": ($event: any) => ((data.sendEmail) = $event),
                  "read-only": !data.email
                }, null, 8, ["modelValue", "onUpdate:modelValue", "read-only"])
              ])
            ]),
            sendSmsTemplateData: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(SwitchToggle, {
                  modelValue: data.sendSms,
                  "onUpdate:modelValue": ($event: any) => ((data.sendSms) = $event),
                  "read-only": !data.mobile
                }, null, 8, ["modelValue", "onUpdate:modelValue", "read-only"])
              ])
            ]),
            _: 1
          }, 8, ["dataSource"])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Add Contact',
          onClick: () => {
            displayFindContactModal.value = true;
          },
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Send',
          onClick: () => {
            onSendClick();
          },
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "width", "showCloseConfirmationPrompt", "loadingContent"]),
    _createVNode(EmailTemplatesConfigurationModal, {
      modelValue: displayEmailTemplateModal.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((displayEmailTemplateModal).value = $event)),
      onConfigurationSelected: onEmailTemplateSelected,
      accessedFromConfigurationScreen: false,
      templateForAppointmentType: true
    }, null, 8, ["modelValue"]),
    _createVNode(SmsTextsConfigurationTemplates, {
      modelValue: displaySmsTemplateModal.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((displaySmsTemplateModal).value = $event)),
      onTemplateSelected: onSmsTemplateSelected,
      "accessed-from-configuration-screen": false
    }, null, 8, ["modelValue"]),
    _createVNode(EmailFormModal, {
      modelValue: displayEmailConfirmationModal.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((displayEmailConfirmationModal).value = $event)),
      "appointment-id": __props.appointment.id,
      emailTemplateId: templateIdForEmailConfirmation.value,
      "contact-list": contactListForEmailConfirmation.value,
      "user-id": currentUserDetails.value?.id,
      onEmailSent: onEmailSent,
      onCancelPromptAccepted: onCancelPromptAccepted
    }, null, 8, ["modelValue", "appointment-id", "emailTemplateId", "contact-list", "user-id"]),
    _createVNode(EmailFormModal, {
      modelValue: displayEmailNotificationModal.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((displayEmailNotificationModal).value = $event)),
      "appointment-id": __props.appointment.id,
      emailTemplateId: templateIdForEmailNotification.value,
      "contact-list": contactListForEmailNotification.value,
      "user-id": currentUserDetails.value?.id,
      onEmailSent: onEmailSent,
      onCancelPromptAccepted: onCancelPromptAccepted
    }, null, 8, ["modelValue", "appointment-id", "emailTemplateId", "contact-list", "user-id"]),
    _createVNode(SmsForm, {
      modelValue: displaySmsConfirmationModal.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((displaySmsConfirmationModal).value = $event)),
      "appointment-id": __props.appointment.id,
      "contact-list": contactListForSmsConfirmation.value,
      smsTemplate: templateIdForSmsConfirmation.value,
      "user-id": currentUserDetails.value?.id,
      onSmsSent: onSmsSent,
      onCancelPromptAccepted: onCancelPromptAccepted
    }, null, 8, ["modelValue", "appointment-id", "contact-list", "smsTemplate", "user-id"]),
    _createVNode(SmsForm, {
      modelValue: displaySmsNotificationModal.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((displaySmsNotificationModal).value = $event)),
      "appointment-id": __props.appointment.id,
      "contact-list": contactListForSmsNotification.value,
      smsTemplate: templateIdForSmsNotification.value,
      "user-id": currentUserDetails.value?.id,
      onSmsSent: onSmsSent,
      onCancelPromptAccepted: onCancelPromptAccepted
    }, null, 8, ["modelValue", "appointment-id", "contact-list", "smsTemplate", "user-id"]),
    _createVNode(FindContactModal, {
      modelValue: displayFindContactModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((displayFindContactModal).value = $event)),
      onContactSelected: onContactSelected
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})